import React from 'react';
import MobileDevPageVideoBtfPrimis from './primis/MobileDevPageVideoBtf';
const MobileDevPageVideoBtf = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(MobileDevPageVideoBtfPrimis, {
        safety: safety
    });
};
MobileDevPageVideoBtf.displayName = 'MobileDevPageVideoBtf';
export default MobileDevPageVideoBtf;
